import { useMemo } from 'react';
import useDefaultTrackingDispatch from './dispatch/useDefaultTrackingDispatch';
import useExternalDispatch from './dispatch/useExternalDispatch';
import { TrackingDispatchProvider } from './TrackingDispatchContext';
import { TrackingStateProvider } from './TrackingStateContext';

type TrackingProviderContentsProps = {
  children?: React.ReactNode;
};

export type TrackingProviderProps = {
  children?: React.ReactNode;
};

const TrackingProviderContents: React.FC<TrackingProviderContentsProps> = ({
  children,
}) => {
  const defaultDispatch = useDefaultTrackingDispatch();
  const externalDispatch = useExternalDispatch();

  return (
    <TrackingDispatchProvider
      dispatch={useMemo(
        () => [defaultDispatch, externalDispatch],
        [defaultDispatch, externalDispatch],
      )}
    >
      {children}
    </TrackingDispatchProvider>
  );
};

const TrackingProvider: React.FC<TrackingProviderProps> = ({ children }) => (
  <TrackingStateProvider>
    <TrackingProviderContents>{children}</TrackingProviderContents>
  </TrackingStateProvider>
);

export default TrackingProvider;
